module.exports = __webpack_public_path__ + "static/media/walling-nMqqEFhInkY-unsplash.2634b9cc.jpg";